import { render, staticRenderFns } from "./NumberingSettings.vue?vue&type=template&id=6cc47b19&"
import script from "./NumberingSettings.vue?vue&type=script&lang=js&"
export * from "./NumberingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports